import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import CircularProgress from '@material-ui/core/CircularProgress'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../../../Components/GenericFlatButton'
import DownloadIcon from 'Assets/Images/icons/download'

const env = process.env.NODE_ENV

const PreviewPdfModal = ({
  onSubmit,
  onCancel,
  title,
  url,
  classes,
  showButtons = true,
  contractName,
}) => {
  const [numPages, setNumPages] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isImage, setIsImage] = useState(false)
  const checkFormat = async () => {
    try {
      const response = await fetch(url)
      const contentType = response.headers.get('Content-Type')
      setIsImage(contentType.includes('image'))
    } catch (error) {}
  }
  useEffect(() => {
    checkFormat()
  }, [])

  pdfjs.GlobalWorkerOptions.workerSrc =
    env == 'development'
      ? `https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js`
      : `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
          pdfjs.version
        }/pdf.worker.min.js`

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }
  const onDownload = async () => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${contractName.replace(' ', '')}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  const downloadImage = async () => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `user_addendum`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  return (
    <div>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classes.pdfWrapper}>
        {isImage ? (
          <div style={{ width: 686, height: 500, overflow: 'scroll' }}>
            <img src={url} id="image" alt="" />
          </div>
        ) : (
          <div className={classes.pdfContainer}>
            <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              // eslint-disable-next-line no-console
              onLoadError={console.error}
              loading={<CircularProgress size={25} />}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={1.2}
                />
              ))}
            </Document>
          </div>
        )}
      </div>
      <div
        className={classNames({
          [classes.buttonContainer]: showButtons,
          [classes.singleButtonContainer]: !showButtons,
        })}
      >
        {showButtons && (
          <GenericFlatButton
            type={'outline'}
            title={'Cancel'}
            onClick={() => onCancel()}
          />
        )}
        <GenericFlatButton
          type={'text'}
          title={'Download'}
          icon={<DownloadIcon />}
          onClick={() => (isImage ? downloadImage() : onDownload())}
        />
        {showButtons && (
          <GenericFlatButton
            type={'filled'}
            title={'Generate contract and send'}
            disabled={isLoading}
            loading={isLoading}
            onClick={async () => {
              setIsLoading(true)
              await onSubmit()
              setIsLoading(false)
            }}
          />
        )}
      </div>
    </div>
  )
}
export default injectStyles(styles)(PreviewPdfModal)
